export default "__VITE_ASSET__c4QGq8av__"